import { Button, Col, Form, Input, message, Row } from 'antd';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { RootState } from '@/store';
import Utils from '@/utils/utils';
import ResizeWrapper from '@/components/ResizeWrapper';
import BubbleMsg from '@/components/BubbleMsg';
import RippleWave from '@/components/RippleWave';
import { useJoin } from '../../lib/useCommon';

import MagicTools from '@/assets/img/magicTool.svg';
import DouBao from '@/assets/img/user_cyber.png';
import styles from './index.module.less';
import Config from '@/config';
import { CalendarPickerView, Collapse, Dialog, List, NavBar, Popup } from 'antd-mobile';
import React, { useEffect, useState } from 'react';
import {
  AddOutline,
  CalendarOutline,
  ClockCircleOutline,
  CloseOutline,
  DeleteOutline,
  MoreOutline
} from 'antd-mobile-icons';
import { post } from '@/utils/request';
import {useNavigate} from "react-router-dom";

export default function() {

  const navigate = useNavigate();
  const [popupVisible, setPopupVisible] = useState(false);

  /**
   * 初始化会话
   */
  const [conversationId, setConversationId] = useState<any>();
  const [conversation, setConversation] = useState<any>({});
  const getConversation = (conversationId: any) => {
    //日期列表
    post('/cbc/history/info', {
      conversationId: conversationId,
    }).then((res) => {
      let data = res.data;
      setConversation(data);
    });
  };

  useEffect(() => {
    const conversationId = Utils.getUrlArgs()?.conversationId;
    setConversationId(conversationId);
    //初始化历史日历
    getConversation(conversationId);
  }, []);

  const clearById  = () => {
    Dialog.show({
      title: '确认删除当前记录吗？',
      content: '确认后，当前记录将会消失，不可恢复。',
      closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: '取消',
          },
          {
            key: 'delete',
            text: '确认删除',
            bold: true,
            danger: true,
            onClick: ()=>{
              post("/cbc/history/deleteById",{
                conversationId:conversationId
              }).then((res)=>{
                if(res.code === 200){
                  setPopupVisible(false);
                }else{
                  message.error(res.msg)
                }
              })
            }
          },
        ],
      ],
    })
  }

  return (
    <ResizeWrapper className={styles.container}>

      <NavBar
        className={styles.navBar}
        style={{ height: 65 }}
        // children={<div className={styles.navBarTitle}>咨询总结</div>}
        children={<img src={require('@/assets/img/his_2.jpg')} style={{ height: 35 }} alt="" />}
        onBack={() => {
          history.back();
        }}
        right={<img style={{width:25,marginRight:10}} src={require("@/assets/img/historyMessage.png")} alt="" onClick={()=>setPopupVisible(true)}/>}
      />

      {/*折叠面板*/}
      <div className={styles.collapseContainer}>
        {
          conversation && <Collapse defaultActiveKey={['1', '2', '3', '4']}>
                <Collapse.Panel key="1" title={(<div className={styles.title}><img src={require('@/assets/img/icon1.png')} alt="" />咨询信息</div>)}>
                    <Row gutter={[0,5]}>
                        <Col span={4}>
                            <div className={styles.subTitle}>时间</div>
                        </Col>
                        <Col span={18}>
                            <div className={styles.content}>
                              {conversation.timeDesc}
                            </div>
                        </Col>
                        <Col span={4}>
                            <div className={styles.subTitle}>时长</div>
                        </Col>
                        <Col span={18}>
                            <div className={styles.content}>
                              {conversation.timeDelayDesc}
                            </div>
                        </Col>
                        <Col span={4}>
                            <div className={styles.subTitle}>主题</div>
                        </Col>
                        <Col span={18}>
                            <div className={styles.content}>
                              {conversation.title}
                            </div>
                        </Col>
                    </Row>
                </Collapse.Panel>
                <Collapse.Panel key="2" title={(<div className={styles.title}><img src={require('@/assets/img/icon2.png')} alt="" />核心论点</div>)}>
                    <div className={styles.content}>{conversation.summary}</div>
                </Collapse.Panel>
                <Collapse.Panel key="3" title={(<div className={styles.title}><img src={require('@/assets/img/icon3.png')} alt="" />交流亮点</div>)}>
                    <Row gutter={[0,5]}>
                      {
                        conversation.pointList && conversation.pointList.map((item: any, index: number) => {
                          return <Col span={24} key={item}>
                            <div className={styles.content}><span className={styles.index1}>{index+1}.</span> {item}</div>
                          </Col>;
                        })
                      }
                    </Row>
                </Collapse.Panel>
                <Collapse.Panel key="4" title={(<div className={styles.title}><img src={require('@/assets/img/icon4.png')} alt="" />赛博子曰建议</div>)}>
                    <Row gutter={[0,5]}>
                      {
                        conversation.suggestList && conversation.suggestList.map((item: any, index: number) => {
                          return <Col span={24} key={item}>
                            <div className={styles.content}><span className={styles.index2}>{index+1}.</span> {item}</div>
                          </Col>;
                        })
                      }
                    </Row>
                </Collapse.Panel>
            </Collapse>

        }

      </div>

      <Popup
        visible={popupVisible}
        onMaskClick={() => {
          setPopupVisible(false);
        }}
        position="right"
        bodyStyle={{ width: '60vw' }}
      >
        <div className={styles.popupContent}>
          <List header="">
            <List.Item prefix={<ClockCircleOutline />} arrowIcon={false} onClick={() => {
              navigate(`/history/detail?conversationId=${conversation.id}`)
            }}>
              查看原始对话
            </List.Item>
            <List.Item prefix={<DeleteOutline />} arrowIcon={false} onClick={() => {
              clearById();
            }} className={styles.clear}>
              删除记录
            </List.Item>
          </List>
        </div>
      </Popup>
    </ResizeWrapper>
  );
}
